var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('v-cardheader',{attrs:{"text":_vm.title}},[_vm._t("header")],2),_c('v-cardbody',{attrs:{"padded":_vm.padded}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }